"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaymentMethodAccount = void 0;
const react_1 = __importDefault(require("react"));
const react_intl_1 = require("react-intl");
const roundMoney_1 = require("../../../utils/roundMoney");
const Select_1 = require("./Select");
const PaymentMethodAccount = (props) => {
    const { select, value, hidden, disabled, modificators } = props;
    const { locale } = (0, react_intl_1.useIntl)();
    if (hidden)
        return null;
    return (react_1.default.createElement(Select_1.PaymentMethodSelect, { icon: 'coins', title: react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Payment/Method:account', defaultMessage: 'Account (available {debitOnAccount} CHF)', values: {
                debitOnAccount: (0, roundMoney_1.localizeMoney)(value, locale, 'Payment/MethodAccount'),
            } }), select: select, disabled: disabled, modificators: modificators }));
};
exports.PaymentMethodAccount = PaymentMethodAccount;
//# sourceMappingURL=Account.js.map